import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const PageContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    box-sizing: border-box;
    position: relative;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-bottom: 175px;
        margin: 0;
    `}
`;

export const HeaderGridContainer = styled(Grid)`
    margin-top: 12px;
    padding: 13px 0 13px 16px;
    background: #ffffff;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    position: sticky;
    top: 0;
    ${media.mobileDevice`
     display:none !important;
 `}
`;
export const ContactTitle = styled.span`
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
`;

export const BodyGridContainer = styled(Grid)`
    padding: 10px 16px 0 16px;
    margin-top: 10px;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    opacity: 1;
    ${media.mobileDevice`
     margin-bottom: 8px;
     margin-top: 5px;
     background: #FFFFFF;
     box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #DCDCDC;
    border-radius: 6px;
    opacity: 1;
 `}
`;
export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    padding-left: 1px;
    color: #3c3c3c;
    opacity: 0.7;
    font-size: 13px;
`;
export const BodyTextContainer = styled(Grid)`
    text-align: left;
    letter-spacing: -0.11px;
    padding-left: 1px;
    ${media.mobileDevice`
    padding-left: 1px;
    display: ${(props) => (props.display ? 'flex' : '')};
`}

    .userName {
        color: #000000;
        font-size: 14px;
        font-family: 'AvenirNextWorld Demi';
        display: block;
        //border: 1px solid #00000000;
        opacity: 1;
        ${media.mobileDevice`
        display: inline;
    `}
    }
    .NetworkId {
        font-size: 14px;
        color: #000000;
        font-family: 'AvenirNextWorld italic';
        opacity: 1;
    }
    .userEmail {
        font-size: 14px;
        color: #000000;
        font-family: 'AvenirNextWorld Regular';
        opacity: 1;
        margin-left: 13px;
        ${media.mobileDevice`
            padding-bottom: 12px;
            margin-left: 0px;
        `}
    }
    .role {
        font-size: 14px;
        color: #000000;
        font-family: 'AvenirNextWorld Regular';
        opacity: 1;
        margin-left: 6px;
        ${media.mobileDevice`
        margin-left: 0px;
        `}
    }
    .typeOfAccess {
        font-size: 14px;
        color: #726f93;
        font-family: 'AvenirNextWorld Regular';
    }
`;
